<div class="home">

  <div class="hero">
    <div class="hero__img"></div>
    <div class="hero__button">
      <a [routerLink]="['/heroes']" class="button">
        Heroes
      </a>
    </div>
  </div>

  <div class="description">
    <h6>DEVELOPED BY MIGUEL ZABALA FIGUEROA {{ anio }} &copy;</h6>
  </div>

</div>
